import { ReactNode } from "react";
import { Box, useTheme } from "@mui/material";

export type PageBackgroundProps = {
    children: ReactNode;
};

/**
 * Outer page wrapper for product v2 surfaces (form `12819:67393`, details informations `12819:62356`).
 * Canvas background uses the neutral page token matching Figma `fill_ML0YI7`.
 */
export const PageBackground = (props: PageBackgroundProps) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                backgroundColor: theme.custom.grey[300],
                minHeight: "100%",
                width: "100%",
            }}
        >
            {props.children}
        </Box>
    );
};
